<div class="topdiv" [style.background-color]="backgroundColorScreen">
  <div class="agGridOuterDiv">
    <div>

      <div class="row topRowMargins headerStyle">

        <div class="col-lg-12" style="margin-top: 1%;">

          Vault DNS Access

        </div>

      </div>

    </div>
    <div style="margin-top: 25px;">
      <form novalidate [formGroup]='validations_form'>
        <div class="row">
          <div class="col-lg-6">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCFormulaexpression">Select Company</mat-label>
              <mat-select (selectionChange)="valutGroupcheck($event)" [(ngModel)]="selectedCompanyid" formControlName="compname" required  >
                <mat-option>None</mat-option>
                <mat-option *ngFor="let eachGroup of companyDetails" [value]="eachGroup.companyid" (onSelectionChange)="getCompanyName(eachGroup)" >
                  {{eachGroup.compname}}
                </mat-option>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.compname" >
                <span
                  *ngIf="validations_form.get('compname').hasError(validation.type) && (validations_form.get('compname').dirty || validations_form.get('compname').touched)">
                  {{ validation.message }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-6">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@TMSTAFFMASTERfirstname">Select User</mat-label>
              <mat-select (selectionChange)="dnsGroupcheck($event)" [(ngModel)] = "selectedUserid" formControlName="username" required>
                <mat-option>None</mat-option>
                <mat-option *ngFor="let eachGroup of userObject" [value]="eachGroup.userid" (onSelectionChange)="getUsername(eachGroup)">
                  {{eachGroup.username}}
                </mat-option>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.username">
                <span
                  *ngIf="validations_form.get('username').hasError(validation.type) && (validations_form.get('username').dirty || validations_form.get('username').touched)">
                  {{ validation.message }}
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>

    <div class="row">
      <div class="col-lg-3"></div>
      <ag-grid-angular #Grid style="height:350px;width: 100%;" class="ag-theme-balham" [columnDefs]="columnDefs"
         [animateRows]="true"  [pagination]="true"
        [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableRangeSelection]="true"
        [rowSelection]="onRowSelectionForDNSNames" [debug]="true" [rowClassRules]="rowClassRules"
        [components]="components" (gridReady)="onGridReadyForDNSName($event)"
         [hidden]="!true">
      </ag-grid-angular>
    </div>
    <div class="col-lg">
      <div class="container" style="text-align: center;">
        <div class="row topRowMargins">
          <div class="col-lg-5"></div>
          <div class="col-lg-2" style="display: flex;">
            <button i18n="@@TMRunButton" type="button" [disabled]="!validations_form.valid" (click)="save()"
            [style.background-color]="buttonColor"
            class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;
      margin-top: 12px;">Save</button>
          </div>
          <div class="col-lg-5">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
